import { INVITATION_ACCEPTANCE_SESSION_KEY } from '../const/invitation-acceptance-session-key.const'

export function clearInvitationAcceptanceSession(): void {
  try {
    sessionStorage.removeItem(INVITATION_ACCEPTANCE_SESSION_KEY)
  } catch {
    // sessionStorage may be unavailable in restricted browser contexts
  }
}
